"use client";

import { useIsDark } from "@/context/ThemeContext";
import { twMerge } from "tailwind-merge";

export default function UIUXLayout({ children }) {
  const isdark = useIsDark();
  return (
    <div>
      {/* left top  */}
      <section className="relative translate-x-0 xl:translate-y-0">
        <div
          className={twMerge(
            "absolute top-[450px] lg:top-[607px] left-[-25px] w-[152px] h-[136px] lg:w-[313px] lg:h-[272px] rounded-full rotate-126 blur-[147px]",
            isdark ? "bg-[#8593E8] opacity-20" : "bg-[#A1ADF5] opacity-40"
          )}
        />
        <div
          className={twMerge(
            "absolute top-[550px] lg:top-[753px] left-[-100px] lg:left-[-207px] w-[153px] h-[137px] lg:w-[315px] lg:h-[274px] rounded-full blur-[184px]",
            isdark ? "bg-[#5D6EF3] opacity-20" : "bg-[#2A40E7] opacity-40"
          )}
        />
        <div
          className={twMerge(
            "absolute top-[620px] left-[-100px] lg:top-[986px] lg:left-[-263px] w-[150px] h-[131px] lg:w-[300px] lg:h-[262px] rounded-full blur-[147px]",
            isdark ? "bg-[#FC4FF6] opacity-20" : "bg-[#FF8DFB] opacity-60"
          )}
        />
      </section>

      {/* right middle */}
      <section className="relative sm:-translate-y-60 xl:translate-y-0">
        <div
          className={twMerge(
            "absolute top-[1400px] right-[-70px] lg:top-[1300px] lg:right-[-135px] w-[135px] h-[161px] lg:w-[271px] lg:h-[313px] rounded-full blur-[147px]",
            isdark ? "bg-[#8593E8] opacity-20" : "bg-[#A1ADF5] opacity-60"
          )}
        />
        <div
          className={twMerge(
            "absolute top-[1500px] right-[-50px] w-[137px] h-[163px] lg:w-[274px] lg:h-[315px] rounded-full blur-[184px]",
            isdark ? "bg-[#5D6EF3] opacity-20" : "bg-[#2A40E7] opacity-40"
          )}
        />
        <div
          className={twMerge(
            "absolute top-[1600px] right-[-75px] lg:top-[1700px] lg:right-[-154px] w-[130px] h-[150px] lg:w-[262px] lg:h-[300px] rounded-full blur-[147px]",
            isdark ? "bg-[#FC4FF6] opacity-20" : "bg-[#FF8DFB] opacity-60"
          )}
        />
      </section>

      {/* left bottom */}
      <section className="relative sm:translate-y-20 md:translate-y-70 tablet:-translate-y-60 lg:translate-y-0">
      <div className={twMerge("absolute top-[2900px] lg:top-[2860px] left-[-63px] w-[152px] h-[136px] lg:w-[313px] lg:h-[272px] rounded-full rotate-126 blur-[147px]",  isdark ? "bg-[#8593E8] opacity-40" : "bg-[#A1ADF5] opacity-60")}/>
      <div className={twMerge("absolute left-[-100px] top-[3041px] lg:left-[-131px] w-[153px] h-[137px] lg:w-[315px] lg:h-[275px] rounded-full  rotate-126 blur-[184px]", isdark ? "bg-[#5D6EF3] opacity-40" : "bg-[#2A40E7] opacity-40")}/>
      <div className={twMerge("absolute top-[3100px] left-[-90px] lg:top-[3275px] lg:left-[-187px] w-[150px] h-[131px] lg:w-[300px] lg:h-[262px] rounded-full rotate-126 blur-[147px]",isdark ? "bg-[#FC4FF6] opacity-20" : "bg-[#FF8DFB] opacity-60")}/>
      </section>

      <div className="">{children}</div>
    </div>
  );
}
